import { Navigate, useParams, useSearchParams } from "react-router-dom"

/** Legacy Patient360 route — redirect into Clients sheet tabs. */
export default function Patient360() {
  const { id } = useParams()
  const [params] = useSearchParams()
  const tab = params.get("tab") || "clinic"
  const search = new URLSearchParams()
  if (id) search.set("open", id)
  search.set("tab", tab)
  return <Navigate to={`/app/clients?${search.toString()}`} replace />
}
